import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { B as BadgeBase } from './badge-base-439be9eb.js';
import './utils-17533423.js';

const gravityStatusBadgeCss = ".badge{background-color:var(--gravity-badge-background-color);border-radius:2px;display:flex;pointer-events:none;user-select:auto}.badge--small{--gravity-base-icon-size:14px;height:20px}.badge--large{--gravity-base-icon-size:16px;height:24px}.badge__label{display:block;line-height:0}.badge--overlay{align-items:center;border-radius:2px;box-shadow:inset 0 0 0 1px var(--gravity-badge-border-color, transparent);box-sizing:border-box;display:flex;gap:4px;height:100%;overflow:hidden;padding:0 4px;text-align:center;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.badge--clickable{cursor:pointer;pointer-events:auto}:host{display:inline-block;max-width:100%}.badge--primary{--gravity-badge-background-color:#1B6AEE}.badge--secondary{--gravity-badge-background-color:#F8F8F8;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--warning{--gravity-badge-background-color:#FF9000;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--warning .badge--clickable:hover{background-color:rgba(255, 255, 255, 0.2)}.badge--danger{--gravity-badge-background-color:#DB0A40;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--danger .badge--clickable:hover{background-color:rgba(255, 255, 255, 0.2)}.badge--success{--gravity-badge-background-color:#159D48;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--success .badge--clickable:hover{background-color:rgba(255, 255, 255, 0.1)}.badge--inactive{--gravity-badge-background-color:#EFEFEF;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--inactive .badge--clickable:hover{background-color:rgba(0, 15, 30, 0.05)}.badge--processing{--gravity-badge-background-color:#F4F8FE;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--processing .badge--clickable:hover{background-color:rgba(0, 15, 30, 0.05)}";
const GravityStatusBadgeStyle0 = gravityStatusBadgeCss;

const GravityStatusBadge = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.badgeClicked = createEvent(this, "badgeClicked", 7);
        this.handleClick = () => {
            if (this.clickable) {
                this.badgeClicked.emit();
            }
        };
        this.deriveTextColor = (status) => {
            switch (status) {
                case 'warning':
                    return 'dark';
                case 'danger':
                    return 'light';
                case 'success':
                    return 'light';
                case 'processing':
                    return 'dark';
                case 'inactive':
                    return 'dark-subtle';
            }
        };
        this.clickable = false;
        this.iconName = undefined;
        this.size = 'small';
        this.status = 'success';
    }
    render() {
        var _a, _b;
        const title = this.element.title || ((_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim());
        return (h(BadgeBase, { key: 'bbde97fa82066ecdf0b2892f8d68fb78ac3195a7', onClick: this.handleClick, clickable: this.clickable, class: `badge--${this.status}`, size: this.size, iconName: this.iconName, textColor: this.deriveTextColor(this.status), title: title }, h("slot", { key: '1aba7514da47792edee508890487e53a4d74c417' })));
    }
    get element() { return getElement(this); }
};
GravityStatusBadge.style = GravityStatusBadgeStyle0;

export { GravityStatusBadge as gravity_status_badge };

//# sourceMappingURL=gravity-status-badge.entry.js.map